import type { ChangeEvent, RefObject } from 'react';
import {
  Alert,
  AlertTitle,
  AlertDescription,
  Button,
  Upload,
} from '@jem-open/jem-ui';
import { Download } from 'lucide-react';
import { downloadCsvTemplate } from '../../utils/csvHelpers';

interface UploadStepProps {
  employerName: string;
  fileError: string | null;
  file: File | null;
  fileInputRef: RefObject<HTMLInputElement>;
  onFileChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onRemoveFile: () => void;
}

const UploadStep = ({
  employerName,
  fileError,
  file,
  fileInputRef,
  onFileChange,
  onRemoveFile,
}: UploadStepProps) => (
  <div className="flex flex-col gap-sm">
    <h3 className="text-greyscale-text-body">
      Uploading users for <span className="font-bold text-secondary-surface">{employerName}</span>
    </h3>

    {fileError && (
      <Alert variant="destructive">
        <AlertTitle>Error</AlertTitle>
        <AlertDescription>{fileError}</AlertDescription>
      </Alert>
    )}

    <div>
      <Upload
        state={file ? 'uploaded' : 'default'}
        fileName={file?.name}
        title="Upload a CSV file with user data"
        description="Username is optional — if blank, email will be used. If a user with the same email already exists, only new branches will be added."
        onSelectFile={() => {
          if (fileInputRef.current) {
            fileInputRef.current.value = '';
            fileInputRef.current.click();
          }
        }}
        onRemoveFile={onRemoveFile}
      />
      <input
        ref={fileInputRef}
        type="file"
        accept=".csv"
        aria-label="Upload CSV file"
        onChange={onFileChange}
        className="hidden"
      />
    </div>

    <Button
      variant="link"
      size="medium"
      leftIcon={<Download className="h-5 w-5" />}
      onClick={downloadCsvTemplate}
      className="self-start"
    >
      Download CSV template
    </Button>
  </div>
);

export default UploadStep;
